export default "__VITE_ASSET__1e726fde__"